import React from 'react';
// At the top of your component
import achyScreenshot from '../img/achy_homepage.png'; // adjust path as needed
import achyIcon from '../img/achy_icon.png'; // ADD YOUR ICON PATH HERE
// Add imports for your additional screenshots here:
// import trackingScreenshot from '../img/tracking_screen.png';
// import analyticsScreenshot from '../img/analytics_screen.png';
import calendarScreenshot from '../img/achy_calendar.png';
import reportsScreenshot from '../img/achy_report.png';
import chartsScreenshot from '../img/achy_piechart.png';
import personalizationScreenshot from '../img/achy_personalize.png';
import insightsScreenshot from '../img/achy_insights.png';
import achy_painscale from '../img/achy_painscale.png';


const AchyLandingPage = () => {
    
  const styles = {
    container: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      lineHeight: '1.6',
      color: '#2c3e50',
      background: '#ffffff',
      overflowX: 'hidden',
      margin: 0,
      padding: 0,
    },
    header: {
      position: 'fixed',
      top: 0,
      width: '100%',
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      zIndex: 1000,
      padding: '1rem 0',
      boxShadow: '0 2px 20px rgba(0, 0, 0, 0.05)',
    },
    nav: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 2rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    logo: {
      textAlign: 'center',
    },
    logoText: {
      fontSize: '2.5rem',
      fontWeight: '700',
      background: 'linear-gradient(135deg, #0f3460 0%, #16213e 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      animation: 'pulse 3s ease-in-out infinite',
      marginBottom: '0.25rem',
    },
    logoTagline: {
      fontSize: '0.9rem',
      color: '#5a6c7d',
      fontWeight: '500',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
    },
    hero: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      padding: '10rem 2rem 4rem',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      position: 'relative',
      overflow: 'hidden',
    },
    heroContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '4rem',
      alignItems: 'center',
      position: 'relative',
      zIndex: 1,
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: '800',
      marginBottom: '1.5rem',
      color: '#2c3e50',
      animation: 'fadeInUp 0.8s ease-out',
    },
    heroText: {
      fontSize: '1.5rem',
      color: '#5a6c7d',
      marginBottom: '2.5rem',
      animation: 'fadeInUp 0.8s ease-out 0.2s',
      animationFillMode: 'both',
    },
    downloadButtons: {
      display: 'flex',
      gap: '1.5rem',
      flexWrap: 'wrap',
      animation: 'fadeInUp 0.8s ease-out 0.4s',
      animationFillMode: 'both',
    },
    downloadButtonsBottom: {
      display: 'flex',
      gap: '1.5rem',
      flexWrap: 'wrap',
      justifyContent: 'center',
      animation: 'fadeInUp 0.8s ease-out 0.4s',
      animationFillMode: 'both',
    },
    downloadBtn: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.75rem',
      padding: '1.2rem 2.2rem',
      background: '#000',
      color: 'white',
      textDecoration: 'none',
      borderRadius: '12px',
      fontWeight: '600',
      fontSize: '1.1rem',
      transition: 'all 0.3s ease',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      cursor: 'pointer',
      border: 'none',
    },
    googleBtn: {
      background: '#fff',
      color: '#000',
      border: '2px solid #000',
    },
    phoneMockup: {
      width: '320px',
      height: '680px',
      background: '#000',
      borderRadius: '40px',
      padding: '10px',
      boxShadow: '0 30px 60px rgba(0, 0, 0, 0.3)',
      margin: '0 auto',
      animation: 'float 6s ease-in-out infinite',
    },
    phoneScreen: {
      width: '100%',
      height: '100%',
      background: 'linear-gradient(135deg, #0f3460 0%, #16213e 100%)',
      borderRadius: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '3rem',
      fontWeight: '700',
      position: 'relative',
      overflow: 'hidden',
    },
    features: {
      padding: '5rem 2rem',
      background: 'white',
    },
    featuresContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    sectionTitle: {
      textAlign: 'center',
      fontSize: '3rem',
      marginBottom: '3rem',
      color: '#2c3e50',
    },
    featuresGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '3rem',
    },
    featureCard: {
      textAlign: 'center',
      padding: '2.5rem',
      borderRadius: '20px',
      background: '#f8f9fa',
      transition: 'all 0.3s ease',
    },
    featureIcon: {
      width: '70px',
      height: '70px',
      margin: '0 auto 1.5rem',
      background: 'linear-gradient(135deg, #0f3460 0%, #16213e 100%)',
      borderRadius: '15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '1.75rem',
    },
    featureTitle: {
      fontSize: '1.75rem',
      marginBottom: '1rem',
      color: '#2c3e50',
      fontWeight: '600',
    },
    featureText: {
      color: '#5a6c7d',
      lineHeight: '1.8',
      fontSize: '1.1rem',
    },
    screenshotSection: {
      padding: '5rem 2rem',
      background: '#f8f9fa',
    },
    screenshotContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '4rem',
      alignItems: 'center',
    },
    screenshotText: {
      padding: '2rem',
    },
    screenshotTitle: {
      fontSize: '2.5rem',
      marginBottom: '1.5rem',
      color: '#2c3e50',
      fontWeight: '700',
    },
    screenshotDescription: {
      fontSize: '1.25rem',
      color: '#5a6c7d',
      lineHeight: '1.8',
      marginBottom: '2rem',
    },
    featureList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    featureListItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginBottom: '1.5rem',
      fontSize: '1.1rem',
      color: '#2c3e50',
    },
    checkIcon: {
      width: '24px',
      height: '24px',
      background: 'linear-gradient(135deg, #0f3460 0%, #16213e 100%)',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      flexShrink: 0,
    },
    screenshotPhone: {
      width: '300px',
      height: '640px',
      background: '#000',
      borderRadius: '35px',
      padding: '8px',
      boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2)',
      margin: '0 auto',
    },
    screenshotPhoneAlt: {
      background: '#1a1a1a',
    },
    screenshotImage: {
      width: '100%',
      height: '100%',
      borderRadius: '27px',
      objectFit: 'cover',
      background: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#999',
    },
    multiScreenSection: {
      padding: '5rem 2rem',
      background: 'white',
    },
    multiScreenGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '3rem',
      maxWidth: '1200px',
      margin: '3rem auto',
    },
    screenCard: {
      textAlign: 'center',
    },
    screenCardPhone: {
      width: '240px',
      height: '520px',
      background: '#000',
      borderRadius: '30px',
      padding: '6px',
      margin: '0 auto 1.5rem',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      transition: 'all 0.3s ease',
    },
    screenCardImage: {
      width: '100%',
      height: '100%',
      borderRadius: '24px',
      objectFit: 'cover',
      background: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#999',
      fontSize: '0.9rem',
    },
    screenCardTitle: {
      fontSize: '1.5rem',
      color: '#2c3e50',
      marginBottom: '0.75rem',
      fontWeight: '600',
    },
    screenCardText: {
      color: '#5a6c7d',
      fontSize: '1.05rem',
      lineHeight: '1.6',
    },
    cta: {
      padding: '5rem 2rem',
      background: 'linear-gradient(135deg, #0f3460 0%, #16213e 100%)',
      textAlign: 'center',
      color: 'white',
    },
    ctaTitle: {
      fontSize: '3rem',
      marginBottom: '1.5rem',
      fontWeight: '600',
      color: 'white',
    },
    ctaText: {
      fontSize: '1.5rem',
      marginBottom: '2.5rem',
      opacity: 0.9,
    },
    footer: {
      padding: '2rem',
      textAlign: 'center',
      background: '#2c3e50',
      color: 'white',
      fontSize: '1.1rem',
    },
    accentHighlight: {
      color: '#ff6b35',
      fontWeight: '800',
    },
  };

  // CSS animations as a style tag
  const animationStyles = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.8; }
    }
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    @keyframes float {
      0%, 100% { transform: translateY(0px); }
      50% { transform: translateY(-20px); }
    }
    @keyframes drift {
      0% { transform: translate(0, 0); }
      100% { transform: translate(50px, 50px); }
    }
    .feature-card:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    }
    .download-btn:hover {
      transform: translateY(-3px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
    }
    .screen-card-phone:hover {
      transform: translateY(-10px);
      box-shadow: 0 30px 60px rgba(0, 0, 0, 0.2);
    }
    .accent-dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      background: #ff6b35;
      border-radius: 50%;
      margin-left: 0.5rem;
    }
    @media (max-width: 768px) {
      .hero-content {
        grid-template-columns: 1fr !important;
        text-align: center;
      }
      .hero-title {
        font-size: 3rem !important;
      }
      .phone-mockup {
        width: 280px !important;
        height: 600px !important;
      }
      .app-icon-container {
        justify-content: center !important;
      }
      .download-buttons {
        justify-content: center !important;
      }
      .download-btn {
        flex: 0 1 auto !important;
        min-width: 150px !important;
      }
      .screenshot-container {
        grid-template-columns: 1fr !important;
      }
      .screenshot-container:nth-child(even) {
        direction: ltr !important;
      }
    }
  `;

  return (
    <>
      <style>{animationStyles}</style>
      <div style={styles.container}>
        <header style={styles.header}>
          <nav style={styles.nav}>
            <div style={styles.logo}>
              <div style={styles.logoText}>
                Achy
              </div>
              <div style={styles.logoTagline}>Headache & Migraine Tracker</div>
            </div>
          </nav>
        </header>
        
        <section style={styles.hero}>
          <div style={styles.heroContent} className="hero-content">
            <div>
              <div className="app-icon-container" style={{display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '1.5rem'}}>
                <img 
                  src={achyIcon}
                  alt="Achy app icon"
                  style={{
                    width: '90px',
                    height: '90px',
                    borderRadius: '20px',
                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                  }}
                />
                <div>
                  <h2 style={{fontSize: '2.25rem', fontWeight: '700', color: '#0f3460', margin: 0}}>Achy</h2>
                  <p style={{fontSize: '1.2rem', color: '#5a6c7d', margin: 0}}>Headache Tracking App</p>
                </div>
              </div>
              <h1 style={styles.heroTitle} className="hero-title">
                Track Your Headaches,<br />Find Your <span style={styles.accentHighlight}>Relief</span>
              </h1>
              <p style={styles.heroText}>
                Take control of your migraines and headaches with intelligent tracking, pattern recognition, and personalized insights.
              </p>
              <div style={styles.downloadButtons} className="download-buttons">
                <a href="https://apps.apple.com/us/app/achy-headache-tracker/id6550894097" style={styles.downloadBtn} className="download-btn">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                  <span>Download on the<br />App Store</span>
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.atomsparksoftware.achy&hl=en_US&pli=1" style={{...styles.downloadBtn, ...styles.googleBtn}} className="download-btn">
                  <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor">
                    <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
                  </svg>
                  <span>Get it on<br />Google Play</span>
                </a>
              </div>
            </div>
            <div className="phone-mockup" style={styles.phoneMockup}>
                <div style={{...styles.phoneScreen, padding: 0}}>
                    <img 
                    src={achyScreenshot} 
                    alt="Achy app screenshot"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        borderRadius: '30px'
                    }}
                    />
                </div>
            </div>
          </div>
        </section>
        
        <section style={styles.features}>
          <div style={styles.featuresContainer}>
            <h2 style={styles.sectionTitle}>Everything You Need to Manage Your Headaches</h2>
            <div style={styles.featuresGrid}>
              <div style={styles.featureCard} className="feature-card">
                <div style={styles.featureIcon}>📊</div>
                <h3 style={styles.featureTitle}>Smart Tracking</h3>
                <p style={styles.featureText}>
                  Log headaches quickly with our intuitive interface. Track intensity, duration, triggers, and symptoms with just a few taps.
                </p>
              </div>
              <div style={styles.featureCard} className="feature-card">
                <div style={styles.featureIcon}>🔍</div>
                <h3 style={styles.featureTitle}>Pattern Recognition</h3>
                <p style={styles.featureText}>
                  Discover your headache patterns and triggers with advanced analytics. Understand what causes your pain and how to avoid it.
                </p>
              </div>
              <div style={styles.featureCard} className="feature-card">
                <div style={styles.featureIcon}>📈</div>
                <h3 style={styles.featureTitle}>Detailed Reports</h3>
                <p style={styles.featureText}>
                  Generate comprehensive reports to share with your healthcare provider. Make informed decisions about your treatment.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* New Screenshot Section 1 - Quick Entry */}
        <section style={styles.screenshotSection}>
          <div style={{...styles.screenshotContainer}} className="screenshot-container">
            <div style={styles.screenshotText}>
              <h2 style={styles.screenshotTitle}>Quick & Easy Entry</h2>
              <p style={styles.screenshotDescription}>
                Log your headache in seconds. Our streamlined interface makes tracking pain levels, symptoms, and triggers effortless.
              </p>
              <ul style={styles.featureList}>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>One-tap pain level selection</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Quick trigger identification</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Medication, symptom, location, and trigger tracking</span>
                </li>
              </ul>
            </div>
            <div style={styles.screenshotPhone}>
              <div style={styles.screenshotImage}>
                {/* Replace with your tracking screenshot */}
                <img 
                  src={achy_painscale} // Change to your tracking screenshot
                  alt="Quick entry screen"
                  style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '27px'}}
                />
              </div>
            </div>
            
          </div>
        </section>

        {/* New Screenshot Section 2 - Analytics (reversed layout) */}
        <section style={{...styles.screenshotSection, background: 'white'}}>
          <div style={{...styles.screenshotContainer, direction: 'rtl'}} className="screenshot-container">
            <div style={{...styles.screenshotText, direction: 'ltr'}}>
              <h2 style={styles.screenshotTitle}>Powerful Analytics</h2>
              <p style={styles.screenshotDescription}>
                Visualize your headache patterns with beautiful charts and insights. Discover trends and identify your triggers.
              </p>
              <ul style={styles.featureList}>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Interactive charts and graphs</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Monthly and yearly trends</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Pain intensity heatmaps</span>
                </li>
              </ul>
            </div>
            <div style={{...styles.screenshotPhone, ...styles.screenshotPhoneAlt}}>
              <div style={styles.screenshotImage}>
                {/* Replace with your analytics screenshot */}
                <img 
                  src={chartsScreenshot} // Change to your analytics screenshot
                  alt="Analytics screen"
                  style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '27px'}}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Multi-Screen Showcase Section */}
        <section style={styles.multiScreenSection}>
          <div style={styles.featuresContainer}>
            <h2 style={styles.sectionTitle}>See Achy in Action</h2>
            <div style={styles.multiScreenGrid}>
              <div style={styles.screenCard}>
                <div style={styles.screenCardPhone} className="screen-card-phone">
                  <div style={styles.screenCardImage}>
                    {/* Replace with your calendar screenshot */}
                    <img 
                      src={calendarScreenshot} // Change to calendar screenshot
                      alt="Calendar view"
                      style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '24px'}}
                    />
                  </div>
                </div>
                <h3 style={styles.screenCardTitle}>Calendar View</h3>
                <p style={styles.screenCardText}>
                  Track your headache history with our intuitive calendar. See patterns at a glance.
                </p>
              </div>

              <div style={styles.screenCard}>
                <div style={styles.screenCardPhone} className="screen-card-phone">
                  <div style={styles.screenCardImage}>
                    {/* Replace with your reports screenshot */}
                    <img 
                      src={reportsScreenshot} // Change to reports screenshot
                      alt="Reports"
                      style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '24px'}}
                    />
                  </div>
                </div>
                <h3 style={styles.screenCardTitle}>Detailed Reports</h3>
                <p style={styles.screenCardText}>
                  Generate professional reports to share with your doctor or for personal records.
                </p>
              </div>

              <div style={styles.screenCard}>
                <div style={styles.screenCardPhone} className="screen-card-phone">
                  <div style={styles.screenCardImage}>
                    {/* Replace with your insights screenshot */}
                    <img 
                      src={insightsScreenshot} // Change to insights screenshot
                      alt="Insights"
                      style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '24px'}}
                    />
                  </div>
                </div>
                <h3 style={styles.screenCardTitle}>Smart Insights</h3>
                <p style={styles.screenCardText}>
                  Get personalized insights based on your tracking data and patterns.
                </p>
              </div>

              <div style={styles.screenCard}>
                <div style={styles.screenCardPhone} className="screen-card-phone">
                  <div style={styles.screenCardImage}>
                    {/* Replace with your settings/profile screenshot */}
                    <img 
                      src={personalizationScreenshot} // Change to settings screenshot
                      alt="Customization"
                      style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '24px'}}
                    />
                  </div>
                </div>
                <h3 style={styles.screenCardTitle}>Personalization</h3>
                <p style={styles.screenCardText}>
                  Customize triggers, symptoms, and medications to match your needs.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Feature Highlight with Screenshot */}
        <section style={styles.screenshotSection}>
          <div style={styles.screenshotContainer} className="screenshot-container">
            <div style={styles.screenshotText}>
              <h2 style={styles.screenshotTitle}>Your Health Data, Protected</h2>
              <p style={styles.screenshotDescription}>
                Your privacy is our priority. All your data is securely stored and you have complete control over your information.
              </p>
              <ul style={styles.featureList}>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>No accounts, no sign ups</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Export your data anytime</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>No ads or data selling</span>
                </li>
                <li style={styles.featureListItem}>
                  <div style={styles.checkIcon}>✓</div>
                  <span>Local storage only - no cloud servers</span>
                </li>
              </ul>
            </div>
            <div style={styles.screenshotPhone}>
              <div style={styles.screenshotImage}>
                {/* Replace with your privacy/settings screenshot */}
                <img 
                  src={achyScreenshot} // Change to privacy/settings screenshot
                  alt="Privacy and security"
                  style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '27px'}}
                />
              </div>
            </div>
          </div>
        </section>
        
        <section style={styles.cta}>
          <h2 style={styles.ctaTitle}>Start Your Journey to Fewer Headaches</h2>
          <p style={styles.ctaText}>
            Join thousands who are taking control of their headache management
          </p>
          <div style={styles.downloadButtonsBottom}>
            <a href="https://apps.apple.com/us/app/achy-headache-tracker/id6550894097" style={{...styles.downloadBtn, margin: '0 0.75rem'}} className="download-btn">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
              </svg>
              <span>Download on the<br />App Store</span>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.atomsparksoftware.achy&hl=en_US&pli=1" style={{...styles.downloadBtn, ...styles.googleBtn, margin: '0 0.75rem'}} className="download-btn">
              <svg width="24" height="24" viewBox="0 0 512 512" fill="currentColor">
                <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
              </svg>
              <span>Get it on<br />Google Play</span>
            </a>
          </div>
        </section>
        
        <footer style={styles.footer}>
          <p>&copy; 2025 Atom Spark Software, LLC. All rights reserved.</p>
        </footer>
      </div>
    </>
  );
};

export default AchyLandingPage;